/**
 * Format a Date as the "YYYY-MM-DD HH:MM:SS" string the API expects.
 *
 * The value is built from the local-time getters on purpose — the API stores
 * naive datetimes, so toISOString() would shift every saved value by the
 * timezone offset.
 */
export function toApiDateTime(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;

  const pad = (n) => String(n).padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    + ` ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
